// Regalos que brillan — scripts propios (prefijo mt-)

function initMtReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = entry.target.getAttribute('data-mt-delay') || 0;
          setTimeout(function () {
            entry.target.classList.add('mt-visible');
          }, Number(delay));
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function initMtFaq() {
  var items = document.querySelectorAll('.mt-faq-item');
  if (!items.length) return;
  items.forEach(function (item) {
    var btn = item.querySelector('.mt-faq-item__pregunta');
    var respuesta = item.querySelector('.mt-faq-item__respuesta');
    if (!btn || !respuesta) return;
    btn.addEventListener('click', function () {
      var abierto = item.classList.contains('mt-open');
      items.forEach(function (otro) {
        otro.classList.remove('mt-open');
        var r = otro.querySelector('.mt-faq-item__respuesta');
        if (r) r.style.maxHeight = null;
      });
      if (!abierto) {
        item.classList.add('mt-open');
        respuesta.style.maxHeight = respuesta.scrollHeight + 'px';
      }
    });
  });
}

function initMtProductoGaleria() {
  document.querySelectorAll('[data-mt-galeria]').forEach(function (galeria) {
    var principal = galeria.querySelector('[data-mt-imagen-principal]');
    var miniaturas = galeria.querySelectorAll('.mt-producto__miniatura');
    if (!principal || !miniaturas.length) return;
    miniaturas.forEach(function (btn) {
      btn.addEventListener('click', function () {
        principal.src = btn.getAttribute('data-mt-full');
        principal.alt = btn.getAttribute('data-mt-alt') || '';
        miniaturas.forEach(function (b) { b.classList.remove('mt-active'); });
        btn.classList.add('mt-active');
      });
    });
  });
}

function initMtProductoVariantes() {
  document.querySelectorAll('[data-mt-producto]').forEach(function (seccion) {
    var script = seccion.querySelector('script[data-mt-variantes]');
    if (!script) return;
    var variantes;
    try {
      variantes = JSON.parse(script.textContent);
    } catch (e) {
      return;
    }
    var input = seccion.querySelector('[data-mt-variant-input]');
    var precioEl = seccion.querySelector('[data-mt-precio]');
    var antesEl = seccion.querySelector('[data-mt-precio-antes]');
    var addBtn = seccion.querySelector('[data-mt-add-btn]');
    var addTexto = seccion.querySelector('[data-mt-add-texto]');
    var grupos = seccion.querySelectorAll('.mt-producto__opcion');
    if (!input || !grupos.length) return;

    var textoDisponible = addTexto ? addTexto.textContent.trim() : '';
    var textoAgotado = seccion.getAttribute('data-mt-texto-agotado') || 'Agotado';

    function seleccionActual() {
      var seleccion = [];
      grupos.forEach(function (grupo) {
        var activo = grupo.querySelector('.mt-opcion-valor.mt-active');
        seleccion.push(activo ? activo.getAttribute('data-mt-value') : null);
      });
      return seleccion;
    }

    function encontrarVariante(seleccion) {
      return variantes.find(function (v) {
        return seleccion.every(function (val, i) {
          return val === null || v['option' + (i + 1)] === val;
        });
      });
    }

    function actualizar() {
      var seleccion = seleccionActual();
      var variante = encontrarVariante(seleccion);
      if (!variante) return;
      input.value = variante.id;
      if (precioEl && variante.price_html) {
        precioEl.textContent = variante.price_html;
      }
      if (antesEl) {
        antesEl.textContent = variante.compare_html || '';
        antesEl.hidden = !variante.compare_html;
      }
      if (addBtn) {
        addBtn.disabled = !variante.available;
        if (addTexto) addTexto.textContent = variante.available ? textoDisponible : textoAgotado;
      }
    }

    grupos.forEach(function (grupo) {
      var botones = grupo.querySelectorAll('.mt-opcion-valor');
      botones.forEach(function (btn) {
        btn.addEventListener('click', function () {
          botones.forEach(function (b) { b.classList.remove('mt-active'); });
          btn.classList.add('mt-active');
          actualizar();
        });
      });
    });
  });
}

function mtHasUploadedFile(uploadContainer) {
  return !!uploadContainer.querySelector(
    '.filepond--item, [class*="filepond--item"], .cl-upload--wrapper li, .cl-upload--wrapper [class*="file-item"]'
  );
}

function mtBlockUpload(form, uploadContainer, e) {
  e.preventDefault();
  e.stopImmediatePropagation();
  e.stopPropagation();
  var errorEl = form.querySelector('[data-mt-upload-error]');
  if (errorEl) errorEl.hidden = false;
  uploadContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
}

function initMtRequireUpload() {
  // Delegado en document y en fase de captura: se evalúa en el momento exacto del
  // clic/envío (no al cargar la página), así no importa si el widget de subida de
  // fotos (de una app externa) tarda en aparecer, y se adelanta a cualquier otro
  // manejador de envío del tema.
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('[data-mt-add-btn]');
      if (!btn) return;
      var form = btn.closest('.mt-producto__form');
      if (!form) return;
      var uploadContainer = form.querySelector('.upload-container');
      if (!uploadContainer) return;
      if (!mtHasUploadedFile(uploadContainer)) {
        mtBlockUpload(form, uploadContainer, e);
      } else {
        var errorEl = form.querySelector('[data-mt-upload-error]');
        if (errorEl) errorEl.hidden = true;
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form.classList || !form.classList.contains('mt-producto__form')) return;
      var uploadContainer = form.querySelector('.upload-container');
      if (!uploadContainer) return;
      if (!mtHasUploadedFile(uploadContainer)) {
        mtBlockUpload(form, uploadContainer, e);
      }
    },
    true
  );
}

function mtInitAll() {
  if (window.__mtInitDone) return;
  window.__mtInitDone = true;
  initMtReveal();
  initMtFaq();
  initMtProductoGaleria();
  initMtProductoVariantes();
  initMtRequireUpload();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mtInitAll);
} else {
  mtInitAll();
}
